module.exports = __webpack_public_path__ + "img/SMS.631e2c61.png";